import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
/** フォント */
const fontFamilies = {
    alpha: 'font-alpha',
    base: 'font-display',
    serif: 'font-serif',
};
/**
 * 色設定
 * WARNING: src/style/config/color.js の extendTextColor の中のものを使用する
 */
const colors = {
    base: 'text-base',
    inactive: 'text-inactive',
    link: 'text-link',
    none: '',
    primary: 'text-primary',
    white: 'text-white',
};
/**
 * サイズ設定
 * WARNING: src/style/config/font.js の extendFontSize と同じにする（`head-<size>`）
 */
const sizes = {
    /* eslint-disable sort-keys-fix/sort-keys-fix */
    xxxl: 'text-head-xxxl',
    xxl: 'text-head-xxl',
    xl: 'text-head-xl',
    lg: 'text-head-lg',
    md: 'text-head-md',
    sm: 'text-head-sm',
    xs: 'text-head-xs',
    xxs: 'text-head-xxs',
    none: '',
    /* eslint-enable sort-keys-fix/sort-keys-fix */
};
/**
 * 通常見出し コンポーネント
 * NOTE: デザインシステムのルールに基づいて値を設定をしています
 * WARNING: 設定値の変更, 追加をする場合は、デザインデータの更新必須（none 等は例外）
 * @param props
 * @returns
 */
export const Head = (props) => {
    const { children, className = '', color = 'base', fontFamily = 'base', id, isNormal = false, size = 'md', tagName = 'div', } = props;
    const Tag = tagName;
    return (_jsx(Tag, Object.assign({ className: clsx(colors[color], fontFamilies[fontFamily], isNormal ? 'font-normal' : 'font-bold', sizes[size], className), id: id }, { children: children })));
};
export const headColors = colors;
export const headSizes = sizes;
